export default "__VITE_ASSET__COGsI0jE__"